import React,{useState} from 'react';
import linkifyHtml from 'linkifyjs/html';
import { ReactTinyLink } from "react-tiny-link";
import {Row,Col,Modal, ModalBody,ModalHeader,Badge} from "reactstrap";
import ProjectService from '../../../services/api/Project';
import RunService from '../../../services/api/Run';
import { Scrollbars } from 'react-custom-scrollbars';


const TextMessage = (props) => {
  const [open,setOpen] = useState(false);
  const [projectParameter,setprojectParameter] = useState((''));
  const [runStatus,setrunStatus] = useState((''));
  const [projectName,setProjectName] = useState((''));
  const [jobId,setJobId] = useState((''));
  const textSplitTitle =(msg)=>{
     var newone = msg.split("<p>");
     var latest = newone[1].split('Param')
     return latest[0]
  }
  const textSplitParam =(msg)=>{
     var newone = msg.split("/Param");
     var latest = newone[1].split("</p>");
     return latest[0]
  }
  const showParam = (content) =>{
     var contentwithTag = content.split("/Param");
     var paramContent = contentwithTag[1].split("</p>");
     setprojectParameter(paramContent[0])
  }
  const showPreview = (msg) =>{
     var newone = msg.split("<p>");
     var splitId ;
     var id;
     showParam(newone[1]);
     if(newone[1].includes("##")){
         splitId = newone[1].split("/Param");
         id = splitId[0].split("##");
        getProjectByJobId(id[1]);     
      }else{
         splitId = newone[0].split("viewProject/");
         id = splitId[1].split(">");
        getProjectById(id[0]);
      }
  }
  const showPopupPreview =()=>{
    if (open) {
      setOpen(false)
    } else {
      setOpen(true)
    }
  }

  const getProjectById = (id) =>{
    ProjectService.GetProjectById(id)
      .then((response) => {
          if (response.status === 'SUCCESS') {
          //  setprojectParameter(response.projectDTOS[0].parameterSet)
           response.projectDTOS[0].runStatus!=null?setrunStatus(response.projectDTOS[0].runStatus):setrunStatus("null");
           setProjectName(response.projectDTOS[0].name);
           setJobId(response.jobId);
         }
      });
      showPopupPreview();
  }

  const getProjectByJobId = (id) =>{
    RunService.GetJobRun(id)
      .then((response) => {
        // console.log(JSON.stringify(response))
          //  setprojectParameter(response.parameterSet);
           response.runStatus!=null?setrunStatus(response.runStatus):setrunStatus("null");
           setProjectName(response.name);
           setJobId(response.jobId);
      });
      showPopupPreview();
  }

  const RedirectProject = (msg) =>{
    try{
    var newone = msg.split("<p>");
    var latest = newone[0].split("<a href=");
    var url = latest[1].split(">");
     if(newone[1].includes("##")){
     }else{
       window.open(url[0], "_blank")
     }
    }catch(err){
      // console.log("blank url")
    }

  }

  return <div className="sc-message--text">
    {props.message.includes('/Param') &&<div className={props.authorType === "received" ? "jobTriggerChatStyle" : "jobTriggerChatStyle"}>
    
    {/*<span style={{cursor:"pointer"}} dangerouslySetInnerHTML={{ __html: linkifyHtml(props.message) }}>
                        
                        </span>*/}
                        <span onClick={e =>RedirectProject(props.message)} style={{fontWeight: 600,fontSize: "15px",cursor:"pointer",color: "#4285F4"}}>{textSplitTitle(props.message)}Param</span><br></br>
                        <div onClick={e =>showPreview(props.message)} style={{cursor:"pointer",border:"1px solid #d3d3d3",padding:5,borderRadius:5}}>
                          <span className="overflowStyle" style={{height: "54px"}} dangerouslySetInnerHTML={{ __html: textSplitParam(props.message) }}></span><br></br>
                        </div>
                        </div>
                      }

{props.message.includes('/Cluster') &&<div className={props.authorType === "received" ? "" : "jobTriggerChatStyle jobTriggerChatStyleforCluster"}>
                        <span onClick={e =>RedirectProject(props.message)} style={{fontWeight: 600,cursor:"pointer",color: "#4285F4"}} dangerouslySetInnerHTML={{ __html: props.message }}></span><br></br>
                       
                        </div>
                      }
    {((props.message.includes('<p>http')||props.message.includes('<p><a href=')) && !props.message.includes('localhost'))&&<ReactTinyLink
        cardSize="small"
        showGraphic={true}
        maxLine={2}
        minLine={2}
        url={props.message.replace( /(<([^>]+)>)/ig, '')}
      />
    }

    {(!props.message.includes('/Param')) && (!props.message.includes('/Cluster'))  &&<span className={props.authorType === "received" ?  "codespan" : ""} dangerouslySetInnerHTML={{ __html: linkifyHtml(props.message) }}>
                      </span>
    }

    
    <Modal
        centered
        isOpen={open}
        toogle={showPopupPreview}
        backdrop="static"
      >
      <ModalHeader toggle={showPopupPreview}>Preview Parameter</ModalHeader>
        <ModalBody>
          <Row style={{borderBottom:"1px solid #d3d3d3",padding:5}}>

            <Col><span style={{fontWeight:600}}> Project Name: &nbsp;&nbsp; </span>{projectName} - {jobId}</Col>
            <Col><span style={{fontWeight:600}}>Run Status : &nbsp;&nbsp;</span>
            <span key={runStatus}>
                  {(runStatus === "Starting" || runStatus === "Progress") &&
                    <Badge color="" className="badge-dot"><i className="bg-yellow blink" />{runStatus}</Badge>
                  }
                  {runStatus === "Executing" &&
                    <Badge color="" className="badge-dot"><i className="bg-success blink" />{runStatus}</Badge>
                  }
                  {runStatus === "Cancelled" &&
                    <Badge color="" className="badge-dot"><i className="bg-darkgray" />{runStatus}</Badge>
                  }
                  {runStatus === "Completed" &&
                    <Badge color="" className="badge-dot"><i className="bg-blue" />{runStatus}</Badge>
                  }
                  {runStatus === "Failed" &&
                    <Badge color="" className="badge-dot"><i className="bg-red" />{runStatus}</Badge>
                  }
            </span></Col>
          </Row>
            <Row>
              <Col>
              <br></br>
                <Scrollbars autoHeight autoHeightMin={400} autoHeightMax={450} >
                              <div>{projectParameter !== "" && projectParameter !== null && <p style={{ marginLeft: 5, fontSize: "0.80rem", marginBottom: 150, lineHeight: 2 }}>
                                {
                                  projectParameter.split("<br>").map((i, key) => {
                                    return <div>{i}</div>;
                                  })}
                              </p>
                            }</div>
                            </Scrollbars>
              </Col>
            </Row>
        </ModalBody>
      </Modal>
    </div>
};


export default TextMessage;